// Cliente ligero de Nominatim respetando su política (1 req/s, identificarse, no scrapear).
// Docs: https://operations.osmfoundation.org/policies/nominatim/

const BASE = 'https://nominatim.openstreetmap.org';
const headers = {
  // El navegador no permite User-Agent custom, pero Referer va con la URL de origen, suficiente para uso individual.
  'Accept-Language': 'es,ca,en',
};

let lastCall = 0;
const MIN_INTERVAL_MS = 1100;

async function throttle() {
  const now = Date.now();
  const wait = lastCall + MIN_INTERVAL_MS - now;
  if (wait > 0) await new Promise((r) => setTimeout(r, wait));
  lastCall = Date.now();
}

export async function searchPlace(query, { polygon = true, limit = 5, signal } = {}) {
  if (!query || query.trim().length < 2) return [];
  await throttle();
  const url = new URL(`${BASE}/search`);
  url.searchParams.set('q', query.trim());
  url.searchParams.set('format', 'jsonv2');
  url.searchParams.set('limit', String(limit));
  url.searchParams.set('addressdetails', '1');
  if (polygon) url.searchParams.set('polygon_geojson', '1');
  const res = await fetch(url, { headers, signal });
  if (!res.ok) throw new Error(`Nominatim ${res.status}`);
  const data = await res.json();
  return data.map(normalizeResult);
}

function normalizeResult(r) {
  let geometry = null;
  if (r.geojson) geometry = r.geojson;
  // bounding box fallback: [south, north, west, east]
  let bbox = null;
  if (Array.isArray(r.boundingbox) && r.boundingbox.length === 4) {
    const [south, north, west, east] = r.boundingbox.map(Number);
    bbox = [west, south, east, north];
  }
  return {
    osmId: `${r.osm_type}/${r.osm_id}`,
    name: r.display_name,
    shortName: r.name || r.display_name.split(',')[0],
    type: r.type,
    class: r.class,
    lat: Number(r.lat),
    lon: Number(r.lon),
    bbox,
    geometry,
    importance: r.importance,
  };
}
